<template>
  <div class="show">
    <div class="show-header flex content-center flex-middle">
      <div class="show-header-container flex space-between">
        <div class="show-header-button" @click="handleClickBackButton">
          <p class="show-header-button-back">←</p>
        </div>
        <div class="show-header-requirement flex">
          <p class="show-header-requirement-price">max price: {{ price }}</p>
          <p class="show-header-requirement-size">size: {{ showSizeName }}</p>
        </div>
      </div>
    </div>
    <div class="show-card-container flex flex-middle">
      <ul class="show-card-list">
        <li
          class="show-card"
          v-for="drinkAndCustom in drinkAndCustomArray"
          :key="drinkAndCustom.index"
        >
          <Card :drink="drinkAndCustom" />
        </li>
      </ul>
    </div>
    <div class="show-footer flex content-center flex-middle">
      <button
        class="show-footer-button button"
        @click="getDrinkAndCustom(price, size)"
      >
        Again
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import Card from "../components/Card.vue";
import Vue from "vue";

export default Vue.extend({
  name: "show",
  components: {
    Card
  },
  created() {
    this.$store.dispatch("setLoading", true);
    this.getDrinkAndCustom(this.price, this.size);
    this.$store.dispatch("setLoading", false);
  },
  methods: {
    handleClickBackButton() {
      this.$router.push("/");
    },
    getDrinkAndCustom(price, size) {
      this.$store.dispatch("setLoading", true);
      this.$store.dispatch("getDrinkAndCustom", { price, size });
      this.$store.dispatch("setLoading", false);
    }
  },
  computed: {
    price() {
      return this.$store.state.price;
    },
    size() {
      return this.$store.state.size;
    },
    drinkAndCustomArray() {
      return this.$store.state.drinkAndCustomArray;
    },
    showSizeName() {
      const sizeNum = this.$store.state.size;
      switch (sizeNum) {
        case 1:
          return "Short";
        case 2:
          return "Tall";
        case 3:
          return "Grande";
        case 4:
          return "Venti";
        default:
          return "Tall";
      }
    }
  }
});
</script>
<style lang="scss">
.show {
  position: relative;
  width: 100%;
  height: 100%;
}
.show-header {
  height: 10%;
  width: 100%;
  background: #e8e4e6;
}
.show-header-container {
  max-width: 300px;
  width: 100%;
  margin-top: 2rem;
  .show-header-requirement {
    font-size: 0.8rem;
    color: #004643;
    font-weight: bold;
    .show-header-requirement-price,
    .show-header-requirement-size {
      margin-left: 0.3rem;
    }
  }
}
.show-card-container {
  height: 80%;
  padding: 5% 0;
  background: #004643;
}
.show-card-list {
  display: inline-block;
  width: 100%;
  .show-card {
    max-width: 80%;
    margin: 0 auto;
  }
  .show-card + .show-card {
    margin-top: 5%;
  }
}
.show-footer {
  height: 10%;
}
.icon {
  height: 40%;

  .icon-drink {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80%;
  }
  .icon-price {
    display: flex;
    justify-content: center;
    align-items: baseline;
    height: 20%;
    .icon-price-box {
      margin-left: 5px;
      .icon-price-number {
        font-size: 36px;
        font-weight: bold;
      }
    }
  }
}

.slider-container {
  margin-top: 5%;
  height: 35%;
  .slider {
    height: 50%;
    .slider-name {
      font-weight: bold;
    }
  }
}
.button-contanier {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10%;
}
</style>
